import { AxiosContext } from '../contexts/axios/AxiosContext'
import { useContext } from 'react'

const useAxios = () => {
    return useContext(AxiosContext).axios
}

export default useAxios